import type { CallBeat } from './playScript';
import { m } from '../../../paraglide/messages';

export interface PlayCaptionProps {
  call: CallBeat;
  first: string;
  second: string;
  onReplay: () => void;
}

/** The line under the table: what the example call is doing while it plays,
 *  then the one sentence it demonstrated, with a way to watch it again. */
export const PlayCaption = ({ call, first, second, onReplay }: PlayCaptionProps) => {
  const line =
    call === 'calling'
      ? m.endpoint_play_calling({ first })
      : call === 'failed' || call === 'handoff'
        ? m.endpoint_play_failed({ first, second })
        : call === 'answered'
          ? m.endpoint_play_answered({ second })
          : call === 'settled'
            ? m.endpoint_play_settled({ first, second })
            : '';
  return (
    <p className="mt-3 flex min-h-6 flex-wrap items-center gap-x-3 text-13 text-text-3" aria-live="polite">
      <span>{line}</span>
      {call === 'settled' ? (
        <button
          type="button"
          onClick={onReplay}
          className="mono text-12 text-accent underline-offset-4 hover:underline"
        >
          {m.endpoint_play_replay()}
        </button>
      ) : null}
    </p>
  );
};
